import axios from "axios";

export const fetchNoti = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/notifications/");
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};
export const fetchNoti1 = async (id) => {
  try {
    const response = await axios.get(`http://localhost:8080/webnet-hms/api/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};
